class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this),
    );

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const filterElement = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      );

      if (!filterElement) return;

      const isDisabled = element.classList.contains("is-disabled");

      if (!isDisabled) {
        filterElement.classList.remove("is-disabled");
        filterElement.innerHTML = element.innerHTML;
      } else {
        filterElement.classList.add("is-disabled");
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

class DetailsHolder extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector(".js-facets-desktop");
    this.mainDetailsToggle = this.querySelector("details");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.container
      .querySelectorAll(".facets__summary")
      .forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this)),
      );

    // Initialize facet search functionality
    this.initFacetSearch();
  }

  handleBodyClick(event) {
    const target = event.target;
    const isNotDetails = target !== this.mainDetailsToggle;
    const isNotDetailsElement = !target.closest("details-holder");

    if (isNotDetails && isNotDetailsElement) {
      const holder = target.closest("details-holder");
      this.activeElement = holder ? holder.querySelector("summary") : null;
      this.close();
    }
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;

    setTimeout(() => {
      this.container.querySelectorAll("details").forEach((details) => {
        if (details !== detailsElement) {
          details.removeAttribute("open");
          details.querySelector("summary").setAttribute("aria-expanded", false);
        }
      });

      document.body.addEventListener("click", this.onBodyClick);
    });
  }

  close() {
    this.container.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.querySelector("summary").setAttribute("aria-expanded", false);
    });

    document.body.removeEventListener("click", this.onBodyClick);
  }

  initFacetSearch() {
    // Initialize desktop facet search
    const desktopSearch = this.querySelector("[data-facet-search]");
    if (desktopSearch) {
      this.constructFacetSearch(desktopSearch, "desktop");
    }

    // Initialize mobile facet search
    const mobileSearch = this.querySelector("[data-facet-search-mobile]");
    if (mobileSearch) {
      this.constructFacetSearch(mobileSearch, "mobile");
    }
  }

  constructFacetSearch(searchInput, type) {
    this.searchInput = searchInput;
    this.type = type; // 'desktop' or 'mobile'
    this.facetList = this.getFacetList();
    this.facetItems = this.getFacetItems();
    this.init();
  }

  getFacetList() {
    const filterLabel =
      this.searchInput.getAttribute("data-facet-search") ||
      this.searchInput.getAttribute("data-facet-search-mobile");
    const selector =
      this.type === "desktop"
        ? `[data-facet-list="${filterLabel}"]`
        : `[data-facet-list-mobile="${filterLabel}"]`;
    return this.querySelector(selector);
  }

  getFacetItems() {
    if (!this.facetList) return [];
    return Array.from(this.facetList.querySelectorAll("[data-facet-item]"));
  }

  init() {
    if (!this.searchInput || !this.facetList) return;

    this.debouncedOnSearch = debounce((event) => {
      this.handleSearch(event);
    }, 1000);

    this.searchInput.addEventListener(
      "input",
      this.debouncedOnSearch.bind(this),
    );
    this.searchInput.addEventListener("focus", this.handleFocus.bind(this));
    this.searchInput.addEventListener("blur", this.handleBlur.bind(this));
  }

  handleSearch(event) {
    const searchTerm = event.target.value.toLowerCase().trim();

    if (searchTerm === "") {
      // If search is empty, show only first 3 items
      this.showDefaultItems();
    } else {
      // If searching, show all items and filter by search term
      this.showAllItems();
      this.filterItems(searchTerm);
    }
  }

  handleFocus(event) {
    const searchTerm = event.target.value.toLowerCase().trim();
    if (searchTerm !== "") {
      this.showAllItems();
    }
  }

  handleBlur(event) {
    const searchTerm = event.target.value.toLowerCase().trim();
    if (searchTerm === "") {
      this.showDefaultItems();
    }
  }

  // A shared helper for setting item visibility
  _showItems(items = []) {
    items.forEach((item) => {
      item.style.display = this.type === "desktop" ? "flex" : "block";
    });
  }

  showDefaultItems() {
    this.removeNoResultsMessage();
    this.facetList.classList.remove("searching");
    this._showItems(this.facetItems);
  }

  showAllItems() {
    this.facetList.classList.add("searching");
    this._showItems(this.facetItems);
  }

  filterItems(searchTerm) {
    let visibleItemsCount = 0;
    this.facetItems.forEach((item) => {
      const itemText = item.getAttribute("data-facet-item").toLowerCase();
      const isVisible = itemText.includes(searchTerm);
      item.style.display = isVisible
        ? this.type === "desktop"
          ? "flex"
          : "block"
        : "none";
      if (isVisible) {
        visibleItemsCount++;
      }
    });

    this.removeNoResultsMessage();

    if (visibleItemsCount === 0 && searchTerm !== "") {
      this.createNoResultsMessageElement();
    }
  }

  createNoResultsMessageElement() {
    const noResultsElement = document.createElement("li");
    noResultsElement.className =
      "list-menu__item facets__item facet-no-results";
    noResultsElement.innerHTML = `<span class="facet-checkbox facet-no-results__message">${window.theme.strings.facets.no_search_results}</span>`;
    this.facetList.appendChild(noResultsElement);
  }

  removeNoResultsMessage() {
    const existingNoResults = this.facetList.querySelector(".facet-no-results");
    if (existingNoResults) {
      existingNoResults.remove();
    }
  }
}

customElements.define("details-holder", DetailsHolder);
